// react
import React, { Component } from "react"
// style
import "./spinner.styl"

class Spinner extends Component {
    render() {
        return (
            <div className="spinner">
                <div>
                    <div />
                    <div />
                </div>
            </div>
        )
    }
}

export default Spinner


/** WEBPACK FOOTER **
 ** ./src/components/common/Spinner/spinner.js
 **/